import React, { useEffect } from 'react'
import ReactGA from 'react-ga';


function Completed() {
  useEffect(() => {
    ReactGA.event({category: "Kongsi Klub Signup", action: 'Completed'});
  }, []);
    return (
      null
    )
}

export default Completed
